exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-NotChrome__Root {\n  background-color: white;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n.cs-NotChrome {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/NotChrome/NotChrome.less
// module id = 1025
// module chunks = 0